import {
  addDays,
  differenceInCalendarDays,
  lastDayOfMonth,
  startOfWeek,
  addWeeks,
  format
} from 'date-fns'
import { Wrapper } from '../../styles/_app.style'
import { SwitcherArea, SwitcherMonthLabel } from '../../styles/timeline/gridAreas'
import DayDropdown from './DayDropdown'
import {MonthButton} from '../../styles/timeline/DayDropdown.styles'
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi'
import React, {useEffect, useRef, useCallback, MutableRefObject} from 'react'

interface DateSwitcherProps { 
  selectedDate: Date
  onDateChange: (newDate: Date) => void
}

export const DateSwitcher: React.FC<DateSwitcherProps> = ({
  selectedDate, 
  onDateChange
}) => {


  const weekStart = startOfWeek(selectedDate, { weekStartsOn: 1 })
  const selectedLabel = format(selectedDate, 'dd/MM/yy');

  // const month = selectedDate.toLocaleString('default', {
  //   month: 'long',
  //   // year: 'numeric',
  // })



  return (
    <SwitcherArea>
      <SwitcherMonthLabel aria-live="polite">{selectedLabel}</SwitcherMonthLabel>
      <Wrapper
        css={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center', 
          width: '100%',
          padding: '0 0.5rem',
          transform: 'translateY(-5px)', 

          '@media (max-width: 900px)': {
            width: 'auto',
            padding: 0,
            transform: 'none',   // 👈 RESET THIS! (Removes the -5px jump)
            margin: 0,
          }


          // paddingBottom: '1rem'
        }}
      >
      
      <MonthButton onClick={() => onDateChange(addWeeks(weekStart, -1))}>
        <FiChevronLeft size={25} />
      </MonthButton>

      <div style={{ flexShrink: 0, margin: '0 0.5rem' }}>
        <DayDropdown
          selectedDate={selectedDate}
          onDateChange={onDateChange}
        />
        </div>

<MonthButton onClick={() => onDateChange(addWeeks(weekStart, +1))}>
<FiChevronRight size={25} />
      </MonthButton>
      </Wrapper>



    </SwitcherArea>
  )
}
